<div class="customPagination">
  <select (change)="onPageSizeChanged()" class="page-size">
    <option *ngFor="let pageS of input.pageSizes" [value]="pageS"
            [selected]="pageS === input.pageSize.toString()">{{pageS}}</option>
  </select>
  <div class="paginationData">
    <span class="lbCurrentPageRange">-</span>
    <span *ngIf="input.totalRows"> of </span>
    <span *ngIf="input.totalRows" id="lbTotalRecords">{{utilService.formatNumber(input.totalRows)}}</span>
  </div>
  <div class="paginationNavigation">
    <i class="site-icon-skip-to-first" [ngClass]="isFirstPage() ? 'disabled' : ''" (click)="onBtFirst()"></i>
    <i class="site-icon-previous" [ngClass]="isFirstPage() ? 'disabled' : ''" (click)="onBtPrevious()"></i>
    <div *ngFor="let button of input.specificPageButtons"
         (click)="utilService.isNumber(button) ? goToPage(button) : null"
         [ngClass]="utilService.isNumber(button) ?
         button === input.page + 1 ?
         'specificPageButton selected' :
         'specificPageButton'
         : ''">{{utilService.formatNumber(button.toString())}}</div>
    <i class="site-icon-next" [ngClass]="isLastPage() ? 'disabled' : ''" (click)="onBtNext()"></i>
    <i *ngIf="input.totalRows" class="site-icon-skip-to-last" [ngClass]="isLastPage() ? 'disabled' : ''"
       (click)="onBtLast()"></i>
  </div>
</div>

<!--[ngClass]="isLastPage() ? 'disabled' : ''"  removed because skip-to-last cant be done because of the size of the data-->
